import {BasePanelWidget} from "../BasePanelWidget";
import {MuNamedWidgets, MuWidget} from "mu-widget/lib/MuWidget";
import {RadioList} from "mu-widget/lib/components/InputList";
import {appTL} from "../gen/tl";
import {customizeRadioListBar} from "../customize";
import {ErrorMarker} from "mu-widget/lib/utils/ErrorMarker";
import {addFlash, memoizeWithChange} from "../utils";
import {Triggers} from "mu-js-utils/lib/Triggers";
import {TNames} from "../TNames";
import {t} from "../translate";
import {UiDayFoodPlan} from "./UiDayFoodPlan";
import {DelayedSingleRun} from "mu-js-utils/lib/DelayedSingleRun";
import {ClientData} from "../types";

export class UiClientData extends BasePanelWidget {
    // @ts-ignore
    muNamedWidget: MuNamedWidgets<{
        gender: RadioList,
        energyUnit: RadioList,
        profile: RadioList,
        palLevelWork: RadioList,
        palLevelSport: RadioList,
        dayFoodPlan: UiDayFoodPlan,
        contents: UiFoodContentCoefficients,
    }>;
    // @ts-ignore
    private errorMarker: ErrorMarker;
    public doLoadMyData = true;
    beforeIndex() {
        this.muAppendContent(`
            <h2>${t('clientDataSectionBasic')}</h2>
            <div class="c-form-pair">
                <label class="c-form-pair__label" mu-for="accountName">${t('signLabelName')}</label>
                <div class="c-form-pair__control-container">
                    <input type="text" mu="accountName#accountName" />
                </div>
            </div>
            <div class="c-form-pair">
                <label class="c-form-pair__label" mu-for="gender">${t('clientDataLabelGender')}</label>
                <div class="c-form-pair__control-container">
                    <div mu="gender:RadioList#gender" />
                </div>
            </div>
            <div class="c-form-pair">
                <label class="c-form-pair__label" mu-for="dtBirth">${t('clientDataLabelDtBirth')}</label>
                <div class="c-form-pair__control-container d-flex-row">
                    <select mu="year#years:@options">
                        <option>Výběr roku</option>
                    </select>
                    <input type="date" mu="dtBirth#dtBirth" />
                </div>
            </div>
            <div class="c-form-pair">
                <label class="c-form-pair__label" mu-for="height">${t('clientDataLabelHeight')}</label>
                <div class="c-form-pair__control-container">
                    <input type="number" mu="height#height" />
                </div>
            </div>
            <div class="c-form-pair">
                <label class="c-form-pair__label" mu-for="mass">${t('clientDataLabelMass')}</label>
                <div class="c-form-pair__control-container">
                    <input type="number" mu="mass#mass" />
                </div>
            </div>
            <div class="c-form-pair">
                <label class="c-form-pair__label" mu-for="palLevelWork">${t('clientDataLabelPalLevelWork')}</label>
                <div class="c-form-pair__control-container">
                    <div mu="palLevelWork:RadioList#palLevelWork" />
                </div>
            </div>
            <div class="c-form-pair">
                <label class="c-form-pair__label" mu-for="palLevelSport">${t('clientDataLabelPalLevelSport')}</label>
                <div class="c-form-pair__control-container">
                    <div mu="palLevelSport:RadioList#palLevelSport" />
                </div>
            </div>
            <div class="c-form-pair">
                <label class="c-form-pair__label" mu-for="profile">${t('clientDataLabelProfile')}</label>
                <div class="c-form-pair__control-container">
                    <div mu="profile:RadioList#profile" />
                </div>
            </div>
            <div class="c-form-pair">
                <label class="c-form-pair__label" mu-for="energyUnit">${t('clientDataLabelEnergyUnit')}</label>
                <div class="c-form-pair__control-container">
                    <div mu="energyUnit:RadioList#energyUnit" />
                </div>
            </div>
            <div mu="cAdvanced#useAdvanced:@visible" style="display: none">            
                <h2>${t('clientDataSectionEnergy')}</h2>
                <div class="c-form-pair">
                    <label class="c-form-pair__label" mu-for="profile">${t('clientDataLabelBasalEnergy')}</label>
                    <div class="c-form-pair__control-container">
                        <div mu="basalEnergyIntake:UiInput" mu-params="type:number,unit:'kCal',auto:'${t('clientDataAutomatic')}'"></div>
                    </div>
                </div>
                <div class="c-form-pair">
                    <label class="c-form-pair__label" mu-for="profile">${t('clientDataLabelRecEnergy')}</label>
                    <div class="c-form-pair__control-container">
                        <div mu="recEnergyIntake:UiInput" mu-params="type:number,unit:'kCal',auto:'${t('clientDataAutomatic')}'"></div>
                    </div>
                </div>
                <h2>${t('clientDataSectionFoodDistribution')}</h2>
                <div>
                    <input type="checkbox" mu="autoContents" checked="checked">
                    <label mu-for="autoContents">${t('clientDataAutomatic')}</label>
                </div>
                <div class="input-with-description" mu="contents:UiFoodContentCoefficients#foodContentCoefficients"></div>
                <div class="component-preview" mu="preview:.#preview">`
                + [
                    { name: 'protein', label: t('proteinContent') },
                    { name: 'carbohydrate', label: t('carbohydrateContent') },
                    { name: 'fatSat', label: t('fatSatContent') },
                    { name: 'fatUnsat', label: t('fatUnsatContent') },
                ].map(item => `<span>
                    <em>${item.label}</em>
                    <span mu="#${item.name}|append('g')"></span>
                </span>`).join('')
                + `</div>
                <h2>${t('clientDataSectionDayPlan')}</h2>
                <div mu="dayFoodPlan:UiDayFoodPlan#dayFoodPlan"></div>
                <div class="c-form-pair">
                    <label class="c-form-pair__label" mu-for="timezone">${t('clientDataLabelTimezone')}</label>
                    <div class="c-form-pair__control-container">
                        <select mu="timezone#timezone;timezoneList:@options"></select>
                    </div>
                </div>
            </div>
            <div class="buttons">
                <button mu="bSave" class="btn btn--primary">${t('genSave')}</button>
                <button mu="bCancel" class="btn btn--cancel">${t('genCancel')}</button>
            </div>
            
        `);
        this.setTitle(t('clientDataTitle'));
    }

    year_change() {
        const year = this.ui.year.value;
        const currentDate = this.ui.dtBirth.value;

        if (!year) return;

        let newDateValue = '';

        if (currentDate) {
            newDateValue = year + currentDate.substring(4);
        } else {
            newDateValue = `${year}-01-01`;
        }

        this.ui.dtBirth.value = newDateValue;
    }

    recEnergyIntake_change() {
        this.updateDayFoodPlanEnergy();
        this.recalculateEnergyD.send();
    }

    updateDayFoodPlanEnergy() {
        this.muNamedWidget.dayFoodPlan.updateEnergyView(parseFloat(this.muNamedWidget.recEnergyIntake.muFetchData().value));
    }

    async afterIndex(): Promise<any> {
        // customizeRadioListBar(this.muNamedWidget.gender.visualParams);
        this.muNamedWidget.gender.visual.addParamDef(customizeRadioListBar({}));
        this.muNamedWidget.energyUnit.visual.addParamDef(customizeRadioListBar({}));
        this.muNamedWidget.palLevelSport.visual.addParamDef(customizeRadioListBar({}, false));
        this.muNamedWidget.palLevelWork.visual.addParamDef(customizeRadioListBar({}, false));
        this.muNamedWidget.profile.visual.addParamDef(customizeRadioListBar({}, false));

        if (this.doLoadMyData) {
            const data = await appTL.getClientDataAndNumberings();

            this.muNamedWidget.gender.items = data.numberings.gender;
            this.muNamedWidget.energyUnit.items = data.numberings.energyUnit;
            this.muNamedWidget.palLevelWork.items = data.numberings.palLevelWork;
            this.muNamedWidget.palLevelSport.items = data.numberings.palLevelSport;
            this.muNamedWidget.profile.items = data.numberings.profile;

            this.muBindData({
                timezoneList: data.numberings.timezones,
                ...data.data || {},
                timezone: data.data.timezone ?? Intl.DateTimeFormat().resolvedOptions().timeZone,
            });
        }

        //@ts-ignore
        this.errorMarker = new ErrorMarker(this);

        const firstYear = (new Date()).getFullYear() - 10;
        super.muBindData({ years: [
            { value: '', text: 'Rok narození' },
            ...[...Array(80).keys()].map(i => ({ value: firstYear - i, text: firstYear - i }) ),
        ] });
    }

    async bSave_click() {
        const res = await appTL.saveClientData(this.muFetchData());
        this.errorMarker.markErrors(res.errors);
        addFlash(res.status === 'ok' ? t('clientDataSavedOk') : t('clientDataSavedError'));
        if (res.status === 'ok') {
            Triggers.dispatchAsync(TNames.clientDataChanged);
            await this.closeMe();
        }
    }

    async bCancel_click() {
        await this.closeMe();
    }

    autoContents_change() {
        // this.muVisible(!this.ui.autoContents.checked, 'contents');
        this.muNamedWidget.contents.setDisabled(this.ui.autoContents.checked);
        this.recalculateEnergy();
    }

    muFetchData(): any {
        const data = super.muFetchData();
        const basalEnergyIntake = this.muNamedWidget.basalEnergyIntake.muFetchData();
        const recEnergyIntake = this.muNamedWidget.recEnergyIntake.muFetchData();
        data.lockAttributes = [];
        if (!basalEnergyIntake.auto) data.lockAttributes.push('basalEnergyIntake');
        if (!recEnergyIntake.auto) data.lockAttributes.push('recEnergyIntake');
        if (!this.ui.autoContents.checked) data.lockAttributes.push('contents');
        data.basalEnergyIntake = basalEnergyIntake.value;
        data.recEnergyIntake = recEnergyIntake.value;

        return data;
    }

    muBindData(srcData: any) {
        srcData = {
            lockAttributes: [],
            dayFoodPlan: {
                times: [ 7 * 3600, 19 * 3600],
                energies: [ 100 ],
            },
            ...srcData,
        }
        super.muBindData(srcData);
        this.muNamedWidget.basalEnergyIntake.muBindData({
            value: srcData.basalEnergyIntake,
            auto: !srcData.lockAttributes.includes('basalEnergyIntake'),
        });
        this.muNamedWidget.recEnergyIntake.muBindData({
            value: srcData.recEnergyIntake,
            auto: !srcData.lockAttributes.includes('recEnergyIntake'),
        });
        this.ui.autoContents.checked = !srcData.lockAttributes.includes('contents');
        this.autoContents_change();
        this.updateDayFoodPlanEnergy();
    }

    private recalculateMemoize = memoizeWithChange(
        (data: ClientData) => appTL.calculateEnergy(data)
    );
    async recalculateEnergy() {
        this.recalculateEnergyD.send();
    }
    private recalculateEnergyD = new DelayedSingleRun(
        500,
        async () => {
            const data = this.muFetchData() as ClientData;
            const autoBasalEnergyIntake = !data.lockAttributes.includes('basalEnergyIntake');
            const autoRecEnergyIntake = !data.lockAttributes.includes('recEnergyIntake');
            const autoContents = !data.lockAttributes.includes('contents');
            if (autoBasalEnergyIntake || autoRecEnergyIntake) {
                const { response: computedEnergyPromise, changed } = this.recalculateMemoize(data);
                const computedEnergy = await computedEnergyPromise;
                if (!changed || !computedEnergy) return;
                if (autoBasalEnergyIntake) {
                    this.muNamedWidget.basalEnergyIntake.muBindData({value: computedEnergy.basalEnergyIntake});
                }
                if (autoRecEnergyIntake) {
                    this.muNamedWidget.recEnergyIntake.muBindData({value: computedEnergy.recEnergyIntake});
                }
                if (autoContents) {
                    this.muNamedWidget.contents.muBindData(computedEnergy.foodContentCoefficients);
                }
                this.muNamedWidget.preview.muBindData(computedEnergy.preview);
                this.updateDayFoodPlanEnergy();
            }
        }
    );

    gender_change() { this.recalculateEnergy(); }
    dtBirth_change() { this.recalculateEnergy(); }
    height_change() { this.recalculateEnergy(); }
    mass_change() { this.recalculateEnergy(); }
    palLevelWork_change() { this.recalculateEnergy(); }
    palLevelSport_change() { this.recalculateEnergy(); }
    profile_change() { this.recalculateEnergy(); }
    basalEnergyIntake_change() { this.recalculateEnergy(); }
    contents_change() { this.recalculateEnergy(); }
}

export class UiFoodContentCoefficients extends MuWidget {
    beforeIndex() {
        this.muAppendContent(
            [
                { name: 'proteinPerMass', label: t('proteinPerMass'), unit: 'g/kg' },
                { name: 'fatSatPerMassActive', label: t('fatSatPerMassActive'), unit: 'g/kg' },
                { name: 'fatUnsatPerMassActive', label: t('fatUnsatPerMassActive'), unit: 'g/kg' },
                { name: 'fatSatPerMassTraining', label: t('fatSatPerMassTraining'), unit: 'g/kg' },
                { name: 'fatUnsatPerMassTraining', label: t('fatUnsatPerMassTraining'), unit: 'g/kg' },
                { name: 'activeDayBurnedEnergy', label: t('activeDayBurnedEnergy'), unit: '%Baz' },
                { name: 'trainingDayBurnedEnergy', label: t('trainingDayBurnedEnergy'), unit: '%Baz' },
            ].map(item => `
                <label mu-for="${item.name}" class="input-with-description__description">${item.label}</label>
                <input type="number" mu="${item.name}#${item.name}" step="0.1" mu-change="input_change" />
                <span class="input-with-description__unit">${item.unit}</span>
            `).join('')
        );
        this.muRegisterEvent('change');
    }

    setDisabled(disabled: boolean) {
        for (const el of Object.values(this.ui)) {
            el.disabled = disabled;
        }
    }

    input_change() {
        this.muDispatchEvent('change');
    }
}